import React from 'react';
import ImportMobilisConfigurationView from "./ImportMobilisConfigurationView";
import TaskImportMobilisConfiguration from "../../ws/TaskImportMobilisConfiguration";

export interface ResponseMobilisConfiguration {
    success: boolean
    message: string | null
    error: string | null
}

interface state {
    file: File | null
    response: ResponseMobilisConfiguration | null
}

class ImportMobilisConfigurationContainer extends React.Component {

    public state: state = {file: null, response: null};

    public importMobilisConfiguration(file: File, stopLoading: () => void) {
        new TaskImportMobilisConfiguration().get(file)
            .catch(
                (response) => {
                    this.setState({response: {success:false, error: response.message} as ResponseMobilisConfiguration});
                }
            )
            .then(
                (response) => {
                    if (response !== undefined) {
                        this.setState({response: response});
                    }
                    stopLoading();
                }
            )
    }

    public render() {
        return <ImportMobilisConfigurationView
            importMobilisConfiguration={this.importMobilisConfiguration.bind(this)}
            response={this.state.response}
        />;
    }

}

export default ImportMobilisConfigurationContainer;